import { ModalDialog } from 'components/ModalDialog';
import { ModalLoading } from 'components/ModalLoading';
import { RequestStatus } from 'features/request/requestSlice';
import { useActKC3Download } from 'pages/Project/UerProject/ActKC3List/components/ExportKc3Modal/hooks/useActKC3Download';
import { RadioGroup, Text } from 'uikit';

import { useMemo, useState } from 'react';

const downloadTitle = 'Выгрузка Справки КС-3';

const RADIO_ITEMS = [
    { id: 0, label: 'Выгрузить прочие затраты с учетом детализации', includeOtherDetails: true },
    { id: 1, label: 'Выгрузить прочие затраты без учета детализации', includeOtherDetails: false },
];

export const ExportKc3Modal = ({
    actKC3Id,
    workOrderId,
    closeHandler,
}: {
    actKC3Id: number;
    workOrderId: number;
    closeHandler: () => void;
}) => {
    const [selectedValue, setSelectedValue] = useState(RADIO_ITEMS[0]);

    const { exportActKC3AsExcelStatus, onActKc3AsExcelAbort, onActKc3Download } = useActKC3Download({
        actKC3Id,
        workOrderId,
        includeOtherDetails: selectedValue?.includeOtherDetails,
        closeHandler,
    });

    const isDownloading = useMemo(
        () => exportActKC3AsExcelStatus === RequestStatus.FETCHING,
        [exportActKC3AsExcelStatus],
    );

    return (
        <>
            {isDownloading && <ModalLoading title={downloadTitle} onClose={onActKc3AsExcelAbort} />}

            <ModalDialog
                isOpen
                title="Выгрузка справки кс-3"
                onClose={closeHandler}
                isOnClickOutsideDisable
                btnConfirmLabel="Применить"
                onConfirm={onActKc3Download}
                bodyMinHeight="150px"
            >
                <div style={{ padding: '20px' }}>
                    <Text size="s" view="secondary" style={{ marginBottom: '10px' }}>
                        Способ выгрузки
                    </Text>
                    <RadioGroup
                        size="s"
                        value={selectedValue}
                        items={RADIO_ITEMS}
                        onChange={({ value }) => setSelectedValue(value)}
                    />
                </div>
            </ModalDialog>
        </>
    );
};

ExportKc3Modal.displayName = 'ExportKc3Modal';
